import React, { useState } from 'react';

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const ReorderList = ({ data, onChange, renderItem } : any) => {

  function reorderNumbers(result) {
    const startIndex = result.source.index;
    const endIndex = result.destination.index;
    console.log('startIndex', startIndex)
    console.log('endIndex', endIndex)
    if (startIndex === endIndex) return;

    onChange((newData) => {
      const nums = [...newData];
      const [removed] = nums.splice(startIndex, 1);
      nums.splice(endIndex, 0, removed);
      return nums;
    });
  }

  return (
    <DragDropContext onDragEnd={reorderNumbers}>
      <Droppable droppableId="droppable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            {data.map((val, i) => {
              return (
                <Draggable key={val.id} draggableId={val.id} index={i}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      variant={snapshot.isDragging ? "elevation" : "outlined"}
                      elevation={4}
                    >
                      <div>
                        {renderItem(val, i)}
                      </div>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default ReorderList;